import { Box } from "@primer/react";
import DataGrid, { Column, ColumnFixing, Editing, FilterPanel, FilterRow, HeaderFilter, Pager, Paging, Sorting } from "devextreme-react/data-grid";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Transition } from "semantic-ui-react";
import { SF_DEXUATMIENGIAM_CHANGED } from "../../api/ganMienGiamApi";
import { hinhThucMienGiamApi } from "../../api/hinhThucMienGiamApi";
import { Button } from '../../components/buttons';
import { ComboboxHe } from '../../components/combobox-he';
import ComboboxKhoi from '../../components/combobox-khoi';
import ComboBoxNhomMienGiam from "../../components/combobox-nhommiengiam";
import { ComboboxTruong } from '../../components/combobox-truong';
import { AnimationConfirm } from '../../components/confirm';
import TagBoxHinhThucMienGiam from "../../components/tagbox-hinh-thuc-mien-giam";
import TextWithEllipse from "../../components/text-with-ellipse";
import { useCommonContext } from "../../contexts/common";
import { localStorageHelper } from '../../helpers/localStorage';
import { PageBaseStatus } from '../../models/pageBaseStatus';
import { ganMienGiamFilterStudentModel } from '../../models/request/gan-mien-giam/ganMienGiamFilterStudent';
import { sf_hinhthucmiengiam_chitiet_viewmodel } from "../../models/response/category/sf_hinhthucmiengiam_chitiet";
import { approveGanMienGiamCancel, approveGanMienGiamSubmit, changeGanMienGiamFilterStudent, changeHe, changeHinhThucMienGiam, changeKhoi, changeNhomMienGiam, changeTruong, closeGanMienGiamFilterStudentModal, closeGanMienGiamImportModal, closeGanMienGiamAddNewModal, loadGanMienGiamHinhThucMienGiamStart, loadGanMienGiamHocSinhStart, loadGanMienGiamStart, showGanMienGiamImportModal, showGanMienGiamAddNewModal } from '../../state/actions/ganMienGiamActions';
import { RootState } from '../../state/reducers';
import { GanMienGiamFilterStudentModal } from './filter-student-modal';
import styles from "./GanMienGiamPage.module.css";
import { GanMienGiamImportModal } from './import-modal/GanMienGiamImportModal';
import { GanMienGiamAddNewModal } from './add-new-modal/GanMienGiamAddNewModal';
import { GanMienGiamEditModal } from './edit-modal/GanMienGiamEditModal';


const GanMienGiamPage = () => {
    const state = useSelector((x: RootState) => x.ganMienGiam)
    const grid = useRef<any>();
    const dispatch = useDispatch();
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common)
    const [ma_hs, set_ma_hs] = useState<string>('');
    const [localChitiets, setLocalChitiets] = useState<{ [key: number]: sf_hinhthucmiengiam_chitiet_viewmodel[] }>({});
    const [editingStudent, setEditingStudent] = useState<{ id: number; ma_hs: string; ho_ten: string } | null>(null);
    const { checkAccesiableToV2 } = useCommonContext();

    const {
        //filter,
        is_show_filter_student_modal,
        filterStudent,
        sf_dexuatmiengiams,
        status,
        ts_hocsinhs,
        approve_request,
        is_show_approve_confirm,
        is_show_import_modal,
        is_show_add_new_modal,
        dm_he_id,
        dm_khoi_id,
        dm_truong_id,
        nhom_mien_giam_id,
        hinh_thuc_mien_giam_ids,
        sf_hinhthucmiengiam_chitiets
    } = state;
    const sf_hinhthucmiengiams = useMemo(() => {
        return state.sf_hinhthucmiengiams
    }, [state.sf_hinhthucmiengiams, dm_coso_id])
    const ts_hocsinh_ids = useMemo(() => {
        return ts_hocsinhs.map(x => x.id);
    }, [ts_hocsinhs])


    const isAccessibleUpdate = useMemo(() => {
        if (!checkAccesiableToV2(SF_DEXUATMIENGIAM_CHANGED, 'POST')) return false;
        return true;
    }, [checkAccesiableToV2]);



    useEffect(() => {
        if (status === PageBaseStatus.is_loading) {
            grid.current.instance.beginCustomLoading();
        } else {
            grid.current.instance.endCustomLoading();
        }
    }, [status]);

    useEffect(() => {
        if (nam_hoc !== "") {
            dispatch(loadGanMienGiamHinhThucMienGiamStart(nam_hoc))
        }
    }, [nam_hoc]);

    useEffect(() => {
        const loadChitiets = async () => {
            if (sf_hinhthucmiengiams.length > 0) {
                const chitietsMap: { [key: number]: sf_hinhthucmiengiam_chitiet_viewmodel[] } = { ...localChitiets };
                for (const hinhThuc of sf_hinhthucmiengiams) {
                    if (!chitietsMap[hinhThuc.id] && !sf_hinhthucmiengiam_chitiets[hinhThuc.id]) {
                        try {
                            const res = await hinhThucMienGiamApi.select_chitiets(hinhThuc.id);
                            if (res.is_success) {
                                chitietsMap[hinhThuc.id] = res.data;
                            }
                        } catch (error) {
                            console.error(`Error loading chitiet for ${hinhThuc.id}:`, error);
                        }
                    }
                }
                if (Object.keys(chitietsMap).length !== Object.keys(localChitiets).length) {
                    setLocalChitiets(chitietsMap);
                }
            }
        };
        loadChitiets();
    }, [sf_hinhthucmiengiams]);

    useEffect(() => {
        dispatch(loadGanMienGiamHocSinhStart({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc
        }))
        dispatch(loadGanMienGiamStart({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc
        }))
        localStorageHelper.setNamHocTruongKhoiFilter({
            dm_he_id: dm_he_id !== undefined ? dm_he_id : 0,
            dm_khoi_id: dm_khoi_id !== undefined ? dm_khoi_id : 0,
            dm_truong_id: dm_truong_id !== undefined ? dm_truong_id : 0,
            nam_hoc: nam_hoc
        })
    }, [dm_he_id, dm_khoi_id, dm_truong_id, nam_hoc]);

    useEffect(() => {
        if (status === PageBaseStatus.is_need_reload)
            dispatch(loadGanMienGiamStart({
                dm_he_id: dm_he_id,
                dm_khoi_id: dm_khoi_id,
                dm_truong_id: dm_truong_id,
                nam_hoc: nam_hoc
            }))

    }, [status]);


    const handleApprove = async (sf_hinhthucmiengiam_id: number, is_approved: boolean) => {
        dispatch(approveGanMienGiamSubmit({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc,
            is_approved: is_approved,
            sf_hinhthucmiengiam_id: sf_hinhthucmiengiam_id,
            ts_hocsinh_ids: ts_hocsinh_ids

        }))
    }

    const renderTitleHeader = useCallback((data: any) => {
        let sf_hinhthucmiengiam_id = parseInt(data.column.name.replace("M_", "")) || 0
        const length_hinh_thuc_mien_giam = sf_dexuatmiengiams.filter(c => c.sf_hinhthucmiengiam_id === sf_hinhthucmiengiam_id).length;
        return (
            <span>
                {data.column.caption + ' (' + length_hinh_thuc_mien_giam + ')'}
            </span>
        );

    }, [sf_dexuatmiengiams, ts_hocsinh_ids])

    const onlyUnique = (value: any, index: any, self: any) => {
        return self.indexOf(value) === index;
    }
    const dynamicColumns = useMemo(() => {
        let sf_hinhthucmiengiams_temp = sf_hinhthucmiengiams;
        if (hinh_thuc_mien_giam_ids.length > 0) {
            sf_hinhthucmiengiams_temp = sf_hinhthucmiengiams_temp.filter((x: any) => hinh_thuc_mien_giam_ids.includes(x.id));
        }
        const nhomMienGiamIds = Array.isArray(nhom_mien_giam_id) ? nhom_mien_giam_id : (nhom_mien_giam_id ? [nhom_mien_giam_id] : []);
        return sf_hinhthucmiengiams_temp.filter(c => c.dm_coso_id === dm_coso_id && (nhomMienGiamIds.length === 0 || nhomMienGiamIds.includes(c.nhom_mien_giam))).map(x => x.nhom_mien_giam).filter(onlyUnique).map(nhom_mien_giam => {
            return (
                <Column 
                    key={nhom_mien_giam} 
                    dataField={"NHOM_" + nhom_mien_giam}
                    alignment="center" 
                    caption={"Nhóm " + nhom_mien_giam}
                    width={100}
                    allowEditing={false}
                    allowSorting={false}
                    allowFiltering={false}
                    cellRender={(cell) => {
                        const value = cell.value;
                        if (value && typeof value === 'string' && value.includes('%')) {
                            return <span style={{ fontWeight: 'bold' }}>{value}</span>
                        }
                        if (value !== undefined && value !== null && value !== '' && value !== false) {
                            return <span>{value}</span>
                        }
                        return <span></span>
                    }}
                />
            );
        })

    }, [sf_hinhthucmiengiams, nhom_mien_giam_id, hinh_thuc_mien_giam_ids, dm_coso_id])
    const dataSource = useMemo(() => {
        let ts_hocsinhs_temp = ts_hocsinhs;
        if (ma_hs !== '') {
            ts_hocsinhs_temp = ts_hocsinhs_temp.filter((x: any) => x.ma_hs.includes(ma_hs) || x.ho_ten.includes(ma_hs) || x.ho_ten.includes(ma_hs.toUpperCase() || x.ma_hs.includes(ma_hs.toUpperCase())))
        }
        let sf_hinhthucmiengiams_temp = sf_hinhthucmiengiams;
        const nhomMienGiamIds = Array.isArray(nhom_mien_giam_id) ? nhom_mien_giam_id : (nhom_mien_giam_id ? [nhom_mien_giam_id] : []);
        const filteredHinhThucs = sf_hinhthucmiengiams_temp.filter(c => c.dm_coso_id === dm_coso_id && (nhomMienGiamIds.length === 0 || nhomMienGiamIds.includes(c.nhom_mien_giam)));
        const uniqueNhoms = filteredHinhThucs.map(x => x.nhom_mien_giam).filter(onlyUnique);
        
        const result = ts_hocsinhs_temp.map(x => {
            const sf_dexuatmiengiam_hocsinhs = sf_dexuatmiengiams.filter(y => y.ts_hocsinh_id === x.id);
            let item: any = {
                id: x.id,
                ma_hs: x.ma_hs,
                ho_ten: x.ho_ten,
                ngay_sinh: x.ngay_sinh,
                trang_thai: x.dm_trangthaihocsinh_trang_thai,
                ten_truong: x.ten_truong,
                ten_khoi: x.ten_khoi,
                ten_he: x.ten_he
            };
            let summary: string[] = [];
            sf_hinhthucmiengiams_temp.forEach(hinhThuc => {
                item["M_" + hinhThuc.id] = '';
            })
            for (let i = 0; i < sf_dexuatmiengiam_hocsinhs.length; i++) {
                const sf_hinhthucmiengiam_id = sf_dexuatmiengiam_hocsinhs[i].sf_hinhthucmiengiam_id;
                const so_lan_ap_dung = sf_dexuatmiengiam_hocsinhs[i].so_lan_ap_dung;
                const sf_hinhthucmiengiam = sf_hinhthucmiengiams_temp.find(x => x.id === sf_hinhthucmiengiam_id);
                
                const chitiets = localChitiets[sf_hinhthucmiengiam_id] || sf_hinhthucmiengiam_chitiets[sf_hinhthucmiengiam_id] || [];
                if (chitiets.length > 0) {
                    const phanTram = Math.max(...chitiets.map((c: any) => c.phan_tram_mien_giam || 0));
                    item["M_" + sf_hinhthucmiengiam_id] = `${phanTram.toFixed(2)}%`;
                } else {
                    item["M_" + sf_hinhthucmiengiam_id] = sf_hinhthucmiengiam?.so_lan_huong_toi_da === 1 ? true : so_lan_ap_dung;
                }

                summary.push(
                    sf_hinhthucmiengiam
                        ? so_lan_ap_dung > 1
                            ? `[${so_lan_ap_dung} lần] x ${sf_hinhthucmiengiam.hinh_thuc_mien_giam}`
                            : `${sf_hinhthucmiengiam.hinh_thuc_mien_giam}\n`
                        : ""
                );

            }
            
            // Tính giá trị cho mỗi nhóm (ưu tiên có data)
            uniqueNhoms.forEach(nhom_mien_giam => {
                const sf_hinhthucmiengiams_nhom = filteredHinhThucs.filter(x => x.nhom_mien_giam === nhom_mien_giam);
                // Tìm giá trị có data đầu tiên (ưu tiên có data)
                let nhomValue = null;
                for (const hinhThuc of sf_hinhthucmiengiams_nhom) {
                    const fieldValue = item["M_" + hinhThuc.id];
                    if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '' && fieldValue !== false) {
                        nhomValue = fieldValue;
                        break; // Lấy giá trị đầu tiên có data
                    }
                }
                item["NHOM_" + nhom_mien_giam] = nhomValue || '';
            });
            
            item = Object.assign({}, item, { summary: summary.join('\n') })
            return item;
        });
        return result;

    }, [ts_hocsinhs, sf_dexuatmiengiams, sf_hinhthucmiengiams, nhom_mien_giam_id, hinh_thuc_mien_giam_ids, ma_hs, localChitiets, sf_hinhthucmiengiam_chitiets, dm_coso_id])

    const handleExport = useCallback(() => {
        if (grid && grid.current && grid.current.instance) {
            grid.current.instance.exportToExcel(false);
        }
    }, [grid])

    return (
        <Box className={styles.container} sx={{ p: 2 }}>
            <Transition animation="scale"
                visible={true}
                duration={100}
                transitionOnMount={true}>
                <div className='row'>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        flexWrap: 'wrap',
                        p: 2,
                        ml: 2,
                        mr: 2,
                        bg: 'canvas.default'
                    }}>
                        <ComboboxTruong
                            value={dm_truong_id}
                            onValueChanged={(value) => {
                                dispatch(changeTruong(value))
                            }}
                            isShowClearButton={true}
                        />
                        <ComboboxKhoi
                            dm_truong_id={dm_truong_id}
                            value={dm_khoi_id}
                            width={150}
                            onValueChanged={(value) => {
                                dispatch(changeKhoi(value))
                            }}
                        />
                        <ComboboxHe
                            width={150}
                            dm_khoi_id={dm_khoi_id}
                            dm_truong_id={dm_truong_id}
                            value={dm_he_id}
                            onValueChanged={(value) => {
                                dispatch(changeHe(value))
                            }}
                        />
                        <ComboBoxNhomMienGiam
                            isShowClearButton={true}
                            maxItemsDisplayText={2}
                            dataSource={sf_hinhthucmiengiams}
                            value={Array.isArray(nhom_mien_giam_id) ? nhom_mien_giam_id : (nhom_mien_giam_id ? [nhom_mien_giam_id] : [])}
                            onValueChanged={(value) => {
                                if (value === null) {
                                    dispatch(changeNhomMienGiam([]))
                                } else if (Array.isArray(value)) {
                                    dispatch(changeNhomMienGiam(value))
                                } else {
                                    dispatch(changeNhomMienGiam([value]))
                                }
                            }}
                        />
                        <TagBoxHinhThucMienGiam
                            width={150}
                            nhom_mien_giam={Array.isArray(nhom_mien_giam_id) ? nhom_mien_giam_id : (nhom_mien_giam_id ? [nhom_mien_giam_id] : [])}
                            isShowClearButton={true}
                            dataSource={sf_hinhthucmiengiams}
                            value={hinh_thuc_mien_giam_ids}
                            maxItemsDisplayText={1}
                            onValueChanged={(value) => {
                                dispatch(changeHinhThucMienGiam(value === null ? [] : value))
                            }}
                        />
                        <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
                            {isAccessibleUpdate &&
                                <Button
                                    id='btnAddNew'
                                    type="normal"
                                    icon="fas fa-plus"
                                    text="Thêm mới"
                                    onClick={() => {
                                        dispatch(showGanMienGiamAddNewModal());
                                    }}
                                />
                            }
                            <Button
                                type="normal"
                                icon="fas fa-redo"
                                text="Refresh"
                                id='btnRefresh'
                                onClick={() => {
                                    dispatch(loadGanMienGiamStart({
                                        dm_he_id: dm_he_id,
                                        dm_khoi_id: dm_khoi_id,
                                        dm_truong_id: dm_truong_id,
                                        nam_hoc: nam_hoc
                                    }))
                                }}
                            />
                            {isAccessibleUpdate &&
                                <Button
                                    id='btnImport'
                                    type="normal"
                                    icon="fas fa-file-excel"
                                    text={`Import`}
                                    onClick={() => {
                                        dispatch(dispatch(showGanMienGiamImportModal()));
                                    }}
                                />
                            }
                            <Button type="normal" icon="fas fa-file-excel" text="Export" onClick={handleExport} />
                        </Box>
                    </Box>

                    <div className="col-md-12" style={{ paddingTop: '5px' }}>
                        <DataGrid
                            ref={grid}
                            keyExpr="id"
                            dataSource={dataSource}
                            columnHidingEnabled={false}
                            remoteOperations={false}
                            columnAutoWidth={true}
                            showBorders={true}
                            showColumnLines={true}
                            showRowLines={true}
                            rowAlternationEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode={"nextColumn"}
                            hoverStateEnabled={true}
                            focusedRowEnabled={false}
                            height={window.innerHeight - 240}
                            className="table table-bordered table-hover "
                            noDataText="Không có dữ liệu"
                            wordWrapEnabled={true}
                            loadPanel={{ enabled: false }}
                            onExporting={(e: any) => {
                                if (e.data && Array.isArray(e.data) && sf_hinhthucmiengiams && dataSource) {
                                    const transformedRows = e.data.map((row: any) => {
                                        const newRow = { ...row };
                                        sf_hinhthucmiengiams.forEach((hinhThuc: any) => {
                                            const fieldName = `M_${hinhThuc.id}`;
                                            if (newRow[fieldName] !== undefined) {
                                                const chitiets = localChitiets[hinhThuc.id] || sf_hinhthucmiengiam_chitiets[hinhThuc.id] || [];
                                                const isSelected = newRow[fieldName] === true || (hinhThuc.so_lan_huong_toi_da > 1 && newRow[fieldName] > 0);
                                                
                                                if (isSelected && chitiets && Array.isArray(chitiets) && chitiets.length > 0) { 
                                                    const phanTramValues = chitiets.map((c: any) => c.phan_tram_mien_giam || 0).filter((v: number) => !isNaN(v));
                                                    if (phanTramValues.length > 0) {
                                                        const phanTram = Math.max(...phanTramValues);
                                                        newRow[fieldName] = `${phanTram.toFixed(2)}%`;
                                                    } else {
                                                        newRow[fieldName] = '';
                                                    }
                                                } else {
                                                    newRow[fieldName] = '';
                                                }
                                            }
                                        });
                                        return newRow;
                                    });
                                    e.data = transformedRows;
                                }
                            }}

                        // paging={{ enabled: true }}

                        >
                            <Sorting mode="multiple" />
                            <Paging defaultPageSize={20}
                                enabled
                            />
                            <Editing
                                mode="cell"
                                allowUpdating={true}
                                allowAdding={false}
                                allowDeleting={false} />
                            <FilterRow visible={true} />
                            <FilterPanel visible={false} />
                            <HeaderFilter visible={true} />.

                            <ColumnFixing enabled={false} />
                            {isAccessibleUpdate && (
                                <Column
                                    dataField="action"
                                    caption="#"
                                    fixed
                                    width={70}
                                    allowEditing={false}
                                    cellRender={(cell) => {
                                        return (
                                            <i
                                                className="fas fa-edit"
                                                onClick={() => {
                                                    setEditingStudent(cell.data);
                                                }}
                                                style={{ cursor: 'pointer', fontSize: '13px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                                title="Sửa"
                                            />
                                        );
                                    }}
                                />
                            )}

                            <Column dataField="trang_thai" caption="Trạng thái" fixed width={100} allowEditing={false} />
                            <Column
                                dataField="ma_hs"
                                caption="Mã HS"
                                fixed
                                width={100}
                                allowEditing={false}
                                cellRender={(cell) => {
                                    return <TextWithEllipse text={cell.value || ''} />
                                }}
                            />
                            <Column
                                dataField="ho_ten"
                                caption="Họ tên"
                                fixed
                                width={150}
                                allowEditing={false}
                                cellRender={(cell) => {
                                    return <TextWithEllipse text={cell.value || ''} />
                                }}
                            />
                            <Column
                                dataField="summary"
                                caption="Đã áp dụng"
                                fixed
                                width={200}
                                allowEditing={false}
                                cellRender={(cell) => {
                                    return <TextWithEllipse text={cell.value || ''} lineNumber={2} allowToggleText={true} />
                                }}
                            />
                           
                            {dynamicColumns}
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[20, 50, 100]}
                                infoText="Trang {0} /{1} ({2} dòng)"
                                showInfo={true} />
                        </DataGrid>
                    </div>
                    {is_show_filter_student_modal &&
                        <GanMienGiamFilterStudentModal
                            animationOf='#btnFilter'
                            filterStudent={filterStudent}
                            onClose={() => { dispatch(closeGanMienGiamFilterStudentModal()) }}
                            onSubmit={(filter: ganMienGiamFilterStudentModel) => {
                                dispatch(changeGanMienGiamFilterStudent(filter))
                                dispatch(closeGanMienGiamFilterStudentModal())
                            }}
                        />
                    }
                    {is_show_approve_confirm && approve_request && <AnimationConfirm
                        animationOf={`btnApprove${approve_request?.sf_hinhthucmiengiam_id}`}
                        onClose={() => { dispatch(approveGanMienGiamCancel()) }}
                        onConfirmed={() => { dispatch(approveGanMienGiamSubmit(approve_request)) }}
                        text={`Bạn có chắc chắn muốn ${approve_request.is_approved ? "áp dụng" : "bỏ áp dụng"} cho tất cả học sinh đang hiển thị`}
                        type={approve_request.is_approved ? "success" : "danger"}
                        is_saving={status === PageBaseStatus.is_saving}
                        icon="fas fa-tasks"
                        text_confirm_button={approve_request.is_approved ? "Áp dụng" : "Bỏ áp dụng"}

                    />
                    }
                    {is_show_import_modal &&
                        <GanMienGiamImportModal
                            nam_hoc={nam_hoc}
                            animationOf="#btnImport"
                            onClose={() => { dispatch(closeGanMienGiamImportModal()) }}
                            onSuccess={() => {
                                dispatch(closeGanMienGiamImportModal())
                                dispatch(loadGanMienGiamStart({
                                    dm_he_id: dm_he_id,
                                    dm_khoi_id: dm_khoi_id,
                                    dm_truong_id: dm_truong_id,
                                    nam_hoc: nam_hoc
                                }))
                            }}

                        />
                    }
                    {is_show_add_new_modal &&
                        <GanMienGiamAddNewModal
                            nam_hoc={nam_hoc}
                            animationOf="#btnAddNew"
                            filter={{
                                nam_hoc: nam_hoc,
                                dm_he_id: dm_he_id,
                                dm_khoi_id: dm_khoi_id,
                                dm_truong_id: dm_truong_id
                            }}
                            onClose={() => { dispatch(closeGanMienGiamAddNewModal()) }}
                            onSuccess={() => {
                                dispatch(closeGanMienGiamAddNewModal())
                                dispatch(loadGanMienGiamStart({
                                    dm_he_id: dm_he_id,
                                    dm_khoi_id: dm_khoi_id,
                                    dm_truong_id: dm_truong_id,
                                    nam_hoc: nam_hoc
                                }))
                            }}
                        />
                    }
                    {editingStudent && (
                        <GanMienGiamEditModal
                            nam_hoc={nam_hoc}
                            animationOf={`#edit_${editingStudent.id}`}
                            ts_hocsinh_id={editingStudent.id}
                            ma_hs={editingStudent.ma_hs}
                            ho_ten={editingStudent.ho_ten}
                            onClose={() => { setEditingStudent(null) }}
                            onSuccess={() => {
                                setEditingStudent(null);
                                dispatch(loadGanMienGiamStart({
                                    dm_he_id: dm_he_id,
                                    dm_khoi_id: dm_khoi_id,
                                    dm_truong_id: dm_truong_id,
                                    nam_hoc: nam_hoc
                                }))
                            }}
                        />
                    )}
                </div>
            </Transition>
        </Box>
    );
}
export default GanMienGiamPage;